import { useCallback, useEffect, useState } from "react"
import { useBlocker } from "react-router-dom"
import { useModal } from "@hooks"

export function useConfirmNavigation(initialDirty = false) {
  const [isDirty, setIsDirty] = useState<boolean>(initialDirty)
  const { confirmLeavePage } = useModal()
  const blocker = useBlocker(({ nextLocation }) => {
    if (nextLocation.pathname.includes("/errors/")) return false

    return isDirty
  })

  useEffect(() => {
    if (blocker.state === "blocked") {
      confirmLeavePage({
        onOk: () => {
          setIsDirty(false)
          blocker.proceed()
        },
        onCancel: blocker.reset,
      })
    }
  }, [blocker.state, blocker.proceed, blocker.reset, confirmLeavePage])

  useEffect(() => {
    return () => {
      setIsDirty(false)
    }
  }, [])

  useEffect(() => {
    if (!isDirty) return

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
    }

    window.addEventListener("beforeunload", handleBeforeUnload)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [isDirty])

  const markDirty = useCallback(() => setIsDirty(true), [])
  const markClean = useCallback(() => setIsDirty(false), [])

  return { isDirty, setIsDirty, markDirty, markClean }
}
